
import { TranslationHandler } from '@/mixins/translation-handler'
import { IFooter, ISocial } from '@/types'
import { Mixins, Component, Prop } from 'vue-property-decorator'
import cms from '@/cms'
import CmsSocialIcon from '@/app/components/CmsSocialIcon.vue'

@Component({
  components: { CmsSocialIcon },
})
export default class Footer extends Mixins(TranslationHandler) {
  @Prop() data!: IFooter;

  get socialLinks (): ISocial[] {
    // Links from CMS components take priority
    // otherwise we fallback to old translation links passed in props
    const cmsLinks = cms.components.resolveSocialLinks()
    if (cmsLinks !== null) {
      return cmsLinks.entries.map((link) => {
        const name = link.platform
        const url = link.url
        return {
          id: name,
          url: url,
        }
      })
    }
    return this.data.socialLinks
  }
}
